import React, {FC, useEffect, useRef} from 'react';

import useScript from 'ui/hooks/useScript';
import * as Metrika from 'ui/utils/metrika';

import {ShareButtonsProps} from './ShareButtons.types';

const SHARE2_SCRIPT = 'https://yastatic.net/share2/share.js';

const {lang} = window.YC;

const ShareButtons: FC<ShareButtonsProps> = ({url, title, image}) => {
    const status = useScript(SHARE2_SCRIPT);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!ref.current || !window.Ya?.share2) {
            return;
        }
        Metrika.share();
        const share = window.Ya.share2(ref.current, {
            content: {
                url,
                title,
                image,
            },
            theme: {
                copy: 'extraItem',
                lang,
                limit: 6,
                services: 'telegram,vkontakte,whatsapp,odnoklassniki',
                size: 'm',
            },
            hooks: {
                onshare: (name: string) => {
                    Metrika.share(name);
                },
            },
        });

        return () => {
            if (share) {
                share.destroy();
            }
        };
    }, [image, status, title, url]);

    return <div ref={ref} />;
};
export default ShareButtons;
